import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
@Component({
  selector: 'nurseapp-customizer',
  templateUrl: './nursecustomizer.component.html',
  styleUrls: ['./nursecustomizer.component.scss']
})
export class NurseCustomizerComponent implements OnInit {

  ngOnInit() {
    // Customizer JS File
    $.getScript('./assets/js/customizer.js');
  }

}
